var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.136 8.08C11.3973 8.08 11.528 8.262 11.528 8.626V12.84C11.528 13.316 11.6167 13.554 11.794 13.554C11.8313 13.554 11.8967 13.5447 11.99 13.526C12.0927 13.498 12.1767 13.484 12.242 13.484C12.634 13.484 12.83 13.7267 12.83 14.212C12.83 14.856 12.5547 15.178 12.004 15.178C11.9107 15.178 11.6493 15.1547 11.22 15.108C10.9587 15.08 10.66 15.066 10.324 15.066C10.156 15.066 9.90867 15.0847 9.582 15.122C9.25533 15.1593 9.01267 15.178 8.854 15.178C8.602 15.178 8.39667 15.094 8.238 14.926C8.07933 14.7487 8 14.5247 8 14.254C8 13.722 8.224 13.456 8.672 13.456C8.672 13.456 8.79333 13.484 9.036 13.54C9.07333 13.5493 9.106 13.554 9.134 13.554C9.302 13.554 9.386 13.2927 9.386 12.77V10.502C9.386 9.97 9.30667 9.704 9.148 9.704C9.12 9.704 9.036 9.72733 8.896 9.774C8.80267 9.79267 8.728 9.802 8.672 9.802C8.224 9.802 8 9.54067 8 9.018C8 8.738 8.07933 8.514 8.238 8.346C8.39667 8.16867 8.60667 8.08 8.868 8.08C8.97067 8.08 9.12 8.094 9.316 8.122C9.64267 8.16867 9.904 8.192 10.1 8.192C10.2587 8.192 10.464 8.17333 10.716 8.136C10.968 8.09867 11.108 8.08 11.136 8.08ZM10.338 7.548C9.99267 7.548 9.694 7.422 9.442 7.17C9.19 6.918 9.064 6.61933 9.064 6.274C9.064 5.91933 9.18533 5.62067 9.428 5.378C9.68 5.126 9.98333 5 10.338 5C10.6927 5 10.9913 5.126 11.234 5.378C11.486 5.62067 11.612 5.91933 11.612 6.274C11.612 6.62867 11.486 6.932 11.234 7.184C10.9913 7.42667 10.6927 7.548 10.338 7.548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackInfoIcon);
export default __webpack_public_path__ + "static/media/blackInfoIcon.e922552ea3f89e3d7cb12d136df1279d.svg";
export { ForwardRef as ReactComponent };